import { DeleteOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { FC } from 'react'
import { formSetsApi } from '../../../../../../../../store/api/form-sets-api'
import { useUpdateFormMutation } from '../../../../../../../../store/api/forms-api'
import { useAppDispatch } from '../../../../../../../../store/store'
import { DocumentId } from '../../../../../../../../types/strapi/strapi'

interface RemoveFormFromSetProps {
    formDocId: DocumentId
    formSetDocId: DocumentId
}

export const RemoveFormFromSet: FC<RemoveFormFromSetProps> = ({ formDocId, formSetDocId }) => {
    const dispatch = useAppDispatch()
    const [updateForm] = useUpdateFormMutation()

    const onConfirm = async () => {
        await updateForm({
            docId: formDocId,
            body: {
                data: {
                    form_set: { disconnect: [formSetDocId] },
                },
            },
        })
        dispatch(formSetsApi.util.invalidateTags(['FormSet']))
    }

    return (
        <Popconfirm
            title='Удалить форму'
            description='Вы уверены?'
            okText='Да'
            cancelText='Нет'
            onConfirm={onConfirm}
        >
            <Button danger icon={<DeleteOutlined />} title='Удалить' />
        </Popconfirm>
    )
}
